import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'

import '@/styles/index.scss' // global css
import '@/styles/date-time-picker.scss' // date-time-picker css
// import 'normalize.css/normalize.css' // a modern alternative to CSS resets
import './icons' // icon

import './plugins/axios'
import './plugins/element.js'
import './plugins/common.js'
import './plugins/moment.js'
import './plugins/permission.js'
import './directives'
import './components'
import './plugins/echarts'
import './plugins/guide'
import './plugins/dayjs'
import './utils/dialog'

import jquery from 'jquery'
window.jquery = window.$ = jquery

import 'babel-polyfill';
import { Button,Popup,Picker,Icon,Overlay,Swipe, SwipeItem,ActionSheet,Cell } from 'vant'
import VueAwesomeSwiper from 'vue-awesome-swiper'
 
// import style
// import 'swiper/css/swiper.css'
import 'swiper/swiper-bundle.css'
import Meta from 'vue-meta'
Vue.use(Meta)
Vue.use(VueAwesomeSwiper, /* { default options with global component } */)

Vue.use(Popup).use(Button).use(Picker).use(Icon).use(Overlay).use(Swipe).use(SwipeItem).use(ActionSheet).use(Cell)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')